import Fe, { useState as K, useEffect as Pe, useCallback as te, createContext as _r, useContext as Rr } from "react";
import { useAuth0 as br, Auth0Provider as wr } from "@auth0/auth0-react";
import Tr from "jwt-decode";
import ne from "js-cookie";
import Sr from "axios";
var B = { exports: {} }, M = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var je;
function xr() {
  if (je) return M;
  je = 1;
  var u = Fe, c = Symbol.for("react.element"), g = Symbol.for("react.fragment"), p = Object.prototype.hasOwnProperty, S = u.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, x = { key: !0, ref: !0, __self: !0, __source: !0 };
  function w(C, f, k) {
    var h, _ = {}, T = null, j = null;
    k !== void 0 && (T = "" + k), f.key !== void 0 && (T = "" + f.key), f.ref !== void 0 && (j = f.ref);
    for (h in f) p.call(f, h) && !x.hasOwnProperty(h) && (_[h] = f[h]);
    if (C && C.defaultProps) for (h in f = C.defaultProps, f) _[h] === void 0 && (_[h] = f[h]);
    return { $$typeof: c, type: C, key: T, ref: j, props: _, _owner: S.current };
  }
  return M.Fragment = g, M.jsx = w, M.jsxs = w, M;
}
var Y = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ae;
function Cr() {
  return Ae || (Ae = 1, process.env.NODE_ENV !== "production" && function() {
    var u = Fe, c = Symbol.for("react.element"), g = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), S = Symbol.for("react.strict_mode"), x = Symbol.for("react.profiler"), w = Symbol.for("react.provider"), C = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), k = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), _ = Symbol.for("react.memo"), T = Symbol.for("react.lazy"), j = Symbol.for("react.offscreen"), L = Symbol.iterator, v = "@@iterator";
    function b(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = L && e[L] || e[v];
      return typeof r == "function" ? r : null;
    }
    var O = u.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function m(e) {
      {
        for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
          t[n - 1] = arguments[n];
        Me("error", e, t);
      }
    }
    function Me(e, r, t) {
      {
        var n = O.ReactDebugCurrentFrame, i = n.getStackAddendum();
        i !== "" && (r += "%s", t = t.concat([i]));
        var s = t.map(function(o) {
          return String(o);
        });
        s.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, s);
      }
    }
    var Ye = !1, Ne = !1, Ve = !1, Ue = !1, qe = !1, oe;
    oe = Symbol.for("react.module.reference");
    function Je(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === p || e === x || qe || e === S || e === k || e === h || Ue || e === j || Ye || Ne || Ve || typeof e == "object" && e !== null && (e.$$typeof === T || e.$$typeof === _ || e.$$typeof === w || e.$$typeof === C || e.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === oe || e.getModuleId !== void 0));
    }
    function Ke(e, r, t) {
      var n = e.displayName;
      if (n)
        return n;
      var i = r.displayName || r.name || "";
      return i !== "" ? t + "(" + i + ")" : t;
    }
    function ie(e) {
      return e.displayName || "Context";
    }
    function P(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && m("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case p:
          return "Fragment";
        case g:
          return "Portal";
        case x:
          return "Profiler";
        case S:
          return "StrictMode";
        case k:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case C:
            var r = e;
            return ie(r) + ".Consumer";
          case w:
            var t = e;
            return ie(t._context) + ".Provider";
          case f:
            return Ke(e, e.render, "ForwardRef");
          case _:
            var n = e.displayName || null;
            return n !== null ? n : P(e.type) || "Memo";
          case T: {
            var i = e, s = i._payload, o = i._init;
            try {
              return P(o(s));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var A = Object.assign, W = 0, se, ue, ce, le, fe, de, ve;
    function pe() {
    }
    pe.__reactDisabledLog = !0;
    function Be() {
      {
        if (W === 0) {
          se = console.log, ue = console.info, ce = console.warn, le = console.error, fe = console.group, de = console.groupCollapsed, ve = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: pe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        W++;
      }
    }
    function Ge() {
      {
        if (W--, W === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: A({}, e, {
              value: se
            }),
            info: A({}, e, {
              value: ue
            }),
            warn: A({}, e, {
              value: ce
            }),
            error: A({}, e, {
              value: le
            }),
            group: A({}, e, {
              value: fe
            }),
            groupCollapsed: A({}, e, {
              value: de
            }),
            groupEnd: A({}, e, {
              value: ve
            })
          });
        }
        W < 0 && m("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var G = O.ReactCurrentDispatcher, X;
    function V(e, r, t) {
      {
        if (X === void 0)
          try {
            throw Error();
          } catch (i) {
            var n = i.stack.trim().match(/\n( *(at )?)/);
            X = n && n[1] || "";
          }
        return `
` + X + e;
      }
    }
    var z = !1, U;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      U = new Xe();
    }
    function he(e, r) {
      if (!e || z)
        return "";
      {
        var t = U.get(e);
        if (t !== void 0)
          return t;
      }
      var n;
      z = !0;
      var i = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var s;
      s = G.current, G.current = null, Be();
      try {
        if (r) {
          var o = function() {
            throw Error();
          };
          if (Object.defineProperty(o.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(o, []);
            } catch (y) {
              n = y;
            }
            Reflect.construct(e, [], o);
          } else {
            try {
              o.call();
            } catch (y) {
              n = y;
            }
            e.call(o.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (y) {
            n = y;
          }
          e();
        }
      } catch (y) {
        if (y && n && typeof y.stack == "string") {
          for (var a = y.stack.split(`
`), E = n.stack.split(`
`), l = a.length - 1, d = E.length - 1; l >= 1 && d >= 0 && a[l] !== E[d]; )
            d--;
          for (; l >= 1 && d >= 0; l--, d--)
            if (a[l] !== E[d]) {
              if (l !== 1 || d !== 1)
                do
                  if (l--, d--, d < 0 || a[l] !== E[d]) {
                    var R = `
` + a[l].replace(" at new ", " at ");
                    return e.displayName && R.includes("<anonymous>") && (R = R.replace("<anonymous>", e.displayName)), typeof e == "function" && U.set(e, R), R;
                  }
                while (l >= 1 && d >= 0);
              break;
            }
        }
      } finally {
        z = !1, G.current = s, Ge(), Error.prepareStackTrace = i;
      }
      var F = e ? e.displayName || e.name : "", D = F ? V(F) : "";
      return typeof e == "function" && U.set(e, D), D;
    }
    function ze(e, r, t) {
      return he(e, !1);
    }
    function He(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function q(e, r, t) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return he(e, He(e));
      if (typeof e == "string")
        return V(e);
      switch (e) {
        case k:
          return V("Suspense");
        case h:
          return V("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case f:
            return ze(e.render);
          case _:
            return q(e.type, r, t);
          case T: {
            var n = e, i = n._payload, s = n._init;
            try {
              return q(s(i), r, t);
            } catch {
            }
          }
        }
      return "";
    }
    var $ = Object.prototype.hasOwnProperty, me = {}, Ee = O.ReactDebugCurrentFrame;
    function J(e) {
      if (e) {
        var r = e._owner, t = q(e.type, e._source, r ? r.type : null);
        Ee.setExtraStackFrame(t);
      } else
        Ee.setExtraStackFrame(null);
    }
    function Ze(e, r, t, n, i) {
      {
        var s = Function.call.bind($);
        for (var o in e)
          if (s(e, o)) {
            var a = void 0;
            try {
              if (typeof e[o] != "function") {
                var E = Error((n || "React class") + ": " + t + " type `" + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[o] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              a = e[o](r, o, n, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (l) {
              a = l;
            }
            a && !(a instanceof Error) && (J(i), m("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", n || "React class", t, o, typeof a), J(null)), a instanceof Error && !(a.message in me) && (me[a.message] = !0, J(i), m("Failed %s type: %s", t, a.message), J(null));
          }
      }
    }
    var Qe = Array.isArray;
    function H(e) {
      return Qe(e);
    }
    function er(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t;
      }
    }
    function rr(e) {
      try {
        return ye(e), !1;
      } catch {
        return !0;
      }
    }
    function ye(e) {
      return "" + e;
    }
    function ge(e) {
      if (rr(e))
        return m("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", er(e)), ye(e);
    }
    var _e = O.ReactCurrentOwner, tr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Re, be;
    function nr(e) {
      if ($.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function ar(e) {
      if ($.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function or(e, r) {
      typeof e.ref == "string" && _e.current;
    }
    function ir(e, r) {
      {
        var t = function() {
          Re || (Re = !0, m("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: t,
          configurable: !0
        });
      }
    }
    function sr(e, r) {
      {
        var t = function() {
          be || (be = !0, m("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: t,
          configurable: !0
        });
      }
    }
    var ur = function(e, r, t, n, i, s, o) {
      var a = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: c,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: t,
        props: o,
        // Record the component responsible for creating this element.
        _owner: s
      };
      return a._store = {}, Object.defineProperty(a._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(a, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: n
      }), Object.defineProperty(a, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: i
      }), Object.freeze && (Object.freeze(a.props), Object.freeze(a)), a;
    };
    function cr(e, r, t, n, i) {
      {
        var s, o = {}, a = null, E = null;
        t !== void 0 && (ge(t), a = "" + t), ar(r) && (ge(r.key), a = "" + r.key), nr(r) && (E = r.ref, or(r, i));
        for (s in r)
          $.call(r, s) && !tr.hasOwnProperty(s) && (o[s] = r[s]);
        if (e && e.defaultProps) {
          var l = e.defaultProps;
          for (s in l)
            o[s] === void 0 && (o[s] = l[s]);
        }
        if (a || E) {
          var d = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          a && ir(o, d), E && sr(o, d);
        }
        return ur(e, a, E, i, n, _e.current, o);
      }
    }
    var Z = O.ReactCurrentOwner, we = O.ReactDebugCurrentFrame;
    function I(e) {
      if (e) {
        var r = e._owner, t = q(e.type, e._source, r ? r.type : null);
        we.setExtraStackFrame(t);
      } else
        we.setExtraStackFrame(null);
    }
    var Q;
    Q = !1;
    function ee(e) {
      return typeof e == "object" && e !== null && e.$$typeof === c;
    }
    function Te() {
      {
        if (Z.current) {
          var e = P(Z.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function lr(e) {
      return "";
    }
    var Se = {};
    function fr(e) {
      {
        var r = Te();
        if (!r) {
          var t = typeof e == "string" ? e : e.displayName || e.name;
          t && (r = `

Check the top-level render call using <` + t + ">.");
        }
        return r;
      }
    }
    function xe(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var t = fr(r);
        if (Se[t])
          return;
        Se[t] = !0;
        var n = "";
        e && e._owner && e._owner !== Z.current && (n = " It was passed a child from " + P(e._owner.type) + "."), I(e), m('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, n), I(null);
      }
    }
    function Ce(e, r) {
      {
        if (typeof e != "object")
          return;
        if (H(e))
          for (var t = 0; t < e.length; t++) {
            var n = e[t];
            ee(n) && xe(n, r);
          }
        else if (ee(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var i = b(e);
          if (typeof i == "function" && i !== e.entries)
            for (var s = i.call(e), o; !(o = s.next()).done; )
              ee(o.value) && xe(o.value, r);
        }
      }
    }
    function dr(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t;
        if (typeof r == "function")
          t = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === _))
          t = r.propTypes;
        else
          return;
        if (t) {
          var n = P(r);
          Ze(t, e.props, "prop", n, e);
        } else if (r.PropTypes !== void 0 && !Q) {
          Q = !0;
          var i = P(r);
          m("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", i || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && m("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function vr(e) {
      {
        for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
          var n = r[t];
          if (n !== "children" && n !== "key") {
            I(e), m("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", n), I(null);
            break;
          }
        }
        e.ref !== null && (I(e), m("Invalid attribute `ref` supplied to `React.Fragment`."), I(null));
      }
    }
    var Oe = {};
    function ke(e, r, t, n, i, s) {
      {
        var o = Je(e);
        if (!o) {
          var a = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (a += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = lr();
          E ? a += E : a += Te();
          var l;
          e === null ? l = "null" : H(e) ? l = "array" : e !== void 0 && e.$$typeof === c ? (l = "<" + (P(e.type) || "Unknown") + " />", a = " Did you accidentally export a JSX literal instead of a component?") : l = typeof e, m("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", l, a);
        }
        var d = cr(e, r, t, i, s);
        if (d == null)
          return d;
        if (o) {
          var R = r.children;
          if (R !== void 0)
            if (n)
              if (H(R)) {
                for (var F = 0; F < R.length; F++)
                  Ce(R[F], e);
                Object.freeze && Object.freeze(R);
              } else
                m("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ce(R, e);
        }
        if ($.call(r, "key")) {
          var D = P(e), y = Object.keys(r).filter(function(gr) {
            return gr !== "key";
          }), re = y.length > 0 ? "{key: someKey, " + y.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Oe[D + re]) {
            var yr = y.length > 0 ? "{" + y.join(": ..., ") + ": ...}" : "{}";
            m(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, re, D, yr, D), Oe[D + re] = !0;
          }
        }
        return e === p ? vr(d) : dr(d), d;
      }
    }
    function pr(e, r, t) {
      return ke(e, r, t, !0);
    }
    function hr(e, r, t) {
      return ke(e, r, t, !1);
    }
    var mr = hr, Er = pr;
    Y.Fragment = p, Y.jsx = mr, Y.jsxs = Er;
  }()), Y;
}
var De;
function Or() {
  return De || (De = 1, process.env.NODE_ENV === "production" ? B.exports = xr() : B.exports = Cr()), B.exports;
}
var N = Or();
const kr = "sessionid", Pr = "csrftoken", Le = "wayflyer-idToken-user", We = "wayflyer-accessToken-user";
function jr({
  accessToken: u,
  idToken: c
}) {
  ne.set(We, u, {
    expires: 1,
    // (days)
    sameSite: "lax",
    secure: !0
  }), ne.set(Le, c, {
    expires: 1,
    // (days)
    sameSite: "lax",
    secure: !0
  });
}
function Yr() {
  for (const u of [
    We,
    Le,
    kr,
    Pr
  ])
    ne.remove(u, {
      sameSite: "lax",
      secure: !0
    });
}
const Ar = 30;
function Dr(u) {
  const c = Tr(u);
  if (!c.exp)
    throw new Error("ID token has no expiry.");
  return (c.exp * 1e3 - Date.now()) / 1e3;
}
const Ir = ({
  children: u
}) => {
  const c = br(), [g, p] = K(null), [S, x] = K(Date.now()), [w, C] = K(navigator.onLine), f = () => {
    C(navigator.onLine);
  }, [k, h] = K(!document.hidden), _ = () => {
    h(!document.hidden);
  };
  Pe(() => {
    if (typeof window < "u" && window.addEventListener)
      return window.addEventListener("online", f), window.addEventListener("offline", f), document.addEventListener("visibilitychange", _), () => {
        window.removeEventListener("online", f), window.removeEventListener("offline", f), document.removeEventListener(
          "visibilitychange",
          _
        );
      };
  }, []);
  const T = te(async () => {
    try {
      const v = await c.getAccessTokenSilently({
        detailedResponse: !0,
        cacheMode: "off"
      });
      jr({
        accessToken: v.access_token,
        idToken: v.id_token
      });
    } catch (v) {
      p(v);
      return;
    }
  }, [c]), j = te(async () => {
    try {
      const v = await c.getAccessTokenSilently({
        detailedResponse: !0,
        cacheMode: "cache-only"
      });
      if (v === void 0)
        return 0;
      const b = v.expires_in, O = Dr(v.id_token);
      return Math.min(b, O);
    } catch (v) {
      p(v);
      return;
    }
  }, [c]), L = te(async () => {
    if (w)
      try {
        await T(), x(Date.now());
      } catch (v) {
        p(v);
      }
  }, [w, T, x, p]);
  return Pe(() => {
    if (g) {
      console.error("Session refresh error", g);
      return;
    } else if (c.error) {
      console.error("Session refresh Auth0 error", c.error);
      return;
    } else if (c.isLoading)
      return;
    const v = (async () => {
      if (!w)
        return;
      const b = await j();
      return b === void 0 ? void 0 : setTimeout(
        L,
        (b - Ar) * 1e3
      );
    })();
    return v.catch((b) => {
      p(b);
    }), () => {
      v.then((b) => {
        b && clearTimeout(b);
      });
    };
  }, [
    c,
    k,
    g,
    S,
    w,
    j,
    L
  ]), /* @__PURE__ */ N.jsx(N.Fragment, { children: u });
}, Nr = (u) => /* @__PURE__ */ N.jsxs(
  wr,
  {
    authorizationParams: {
      audience: u.defaultAudience ?? "wayflyer",
      redirect_uri: window.location.origin
    },
    cacheLocation: "localstorage",
    clientId: u.clientId,
    domain: u.domain,
    useRefreshTokens: !0,
    useRefreshTokensFallback: !0,
    children: [
      u.withSessionRefresher ?? !0 ? /* @__PURE__ */ N.jsx(Ir, {}) : null,
      u.children
    ]
  }
), $e = _r(void 0);
var Ie;
const ae = Sr.create({
  headers: {
    "Content-Type": "application/json",
    "X-CSRFToken": (Ie = document == null ? void 0 : document.querySelector("[name=csrfmiddlewaretoken]")) == null ? void 0 : Ie.getAttribute("value")
  }
});
ae.interceptors.response.use((u) => {
  var c, g, p, S;
  if ((p = (g = (c = u.headers) == null ? void 0 : c["content-type"]) == null ? void 0 : g.includes) != null && p.call(g, "text/html")) {
    const { pathname: x } = u.request.responseURL ? new URL((S = u.request) == null ? void 0 : S.responseURL) : { pathname: "" };
    if (x.startsWith("/authn/"))
      throw window.location.reload(), new Error(
        "Server redirected API request to login page, most likely due to expired session"
      );
  }
  return u.status === 401 && window.location.reload(), u;
});
const Vr = ae, Ur = ({ children: u }) => /* @__PURE__ */ N.jsx($e.Provider, { value: ae, children: u }), qr = () => Rr($e);
export {
  Ir as Auth0SessionRefresher,
  Ur as AxiosProvider,
  Nr as WfAuth0Provider,
  Vr as axiosClient,
  Yr as clearAuthCookies,
  jr as setAuthCookies,
  qr as useAxios
};
//# sourceMappingURL=index.js.map
